<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<h1 class="booktitle">WINE BITES</h1>
<h3 class="subtitle">SIMPLE MORSELS THAT PAIR PERFECTLY WITH WINE</h3>
<p class="byline"><i>by</i></p>
<h3 class="author">Barbara Scott-Goodman</h3>
<p class="othertext"><i>Photographs</i> by Kate Mathis<br/><br/><br/></p>
<div>
<p class="publogo"><img alt="" height="132" src="images/logo.jpg" width="300"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?4ea7222a